import { MapPinSimpleArea } from "@phosphor-icons/react/dist/ssr";
import Flex from "@/shared/components/common/Flex";
import Skeleton from "@/shared/components/common/Skeleton";

export default function BodySkeleton() {
  return (
    <Flex className="w-full flex-col max-h-[490px] overflow-y-auto">
      {new Array(8).fill(0).map((_, z) => (
        <Flex
          className="flex-col w-full h-full border-b py-2 px-2 cursor-pointer hover:bg-muted dark:hover:bg-muted/10 transition-all duration-150 flex gap-3 items-center"
          key={z}
        >
          <Flex className="w-full justify-start items-center gap-x-2">
            <MapPinSimpleArea className="w-4 h-4 text-primary" />
            <Skeleton className="w-10 h-2 rounded-xs" />
          </Flex>
        </Flex>
      ))}
    </Flex>
  );
}
